var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABNVBMVEX///8sLIguMIsuMIsu MYovL4oBAQEuMYouMIsuMYouMIosLIkvMYsvMYsvMYsvMIsuMYsvMYsvMYshMYAsLIAvMYsvMYsu MYsvMYovMYsvMYsuMIsvMIsuLogoKIAvMYsvMYsuMYspKYovL4ovMYsvL4ovMYssMIkqKocvMYov MYsuMYoqKoUuMIoZMHUmJoAvMYsvMYsvMYsvMYovMIsuMYouMIsvMYsvMIovMYovMYsnMYUmJocv MYssMIkvMYsuMYsvMIouLocvMYstMIotMIovMYsuLosuMYovMYktMIouMIkvL4stMIsvMIsBAVYu MIovMYsvL4ktLYkvMYovMYosLIAvMYsrMIcpMYguMYoqKoYvMIotLYsuLoYvMYsvMYsvMYskMIAB AWcvMYoBAYD///85oYFhAAAAZnRSTlMAJH6kijgBRYmVcx52+dCotfOhEBK6+Lunzfp47kQUwtbX GkN6HPdNE9vaUB95Cw7YfKacnauOjK20kBsV9TzFpbgo8W5o6kpbWlJydEySA5P0SS/msgzpNyDM Gc4jF8fh3xYFcAS4VjDUAAAAAWJLR0QAiAUdSAAAAAlwSFlzAABM5QAATOUBdc7wlQAAAAd0SU1F B+YKBAkKKX6XlqAAAADKSURBVBjTY2DAARiZmFlYgTQbOwcnFzdEjIeXj19AUEhYRFRMXEJSShos JiMLJOXkFRTllYAMZRkVBgZVNXWweg1NLWEwQ5tXh0FXEWqynj6UYWDIYGSMbq+JKYORGbqguQUD iyW6oIUVA7uYNaqYja0dA5u9EaqggyOQcHJ2QRZzdQP7yZ3XAyHmCdQMBl5q3jAxHzVfGJPd2c8f RPsHBAYhNAWHhOoxMISFhkcgGx+pGRVtHaMZi+qQuPiERPskdH8kc6WkMuADANRZGDyMLYKrAAAA JXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTEwLTA0VDA5OjEwOjQwKzAwOjAwUcsDYQAAACV0RVh0ZGF0 ZTptb2RpZnkAMjAyMi0xMC0wNFQwOToxMDo0MCswMDowMCCWu90AAAAodEVYdGRhdGU6dGltZXN0 YW1wADIwMjItMTAtMDRUMDk6MTA6NDErMDA6MDDR9JG2AAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart20);
export default __webpack_public_path__ + "static/media/heart-20.76cbc4a7478c9dc4f2b87c7d63f2dfd4.svg";
export { ForwardRef as ReactComponent };